import { createBrowserRouter, RouterProvider, Outlet, Navigate } from "react-router-dom";
import "./App.css";
import Home from "./Screens/Home/Home";
import Appointments from "./Screens/Appointments/Appointments";
import Catalogue from "./Screens/Catalogue/Catalogue";
import Packages from "./Screens/Packages/Packages";
import Worklist from "./Screens/Results/Worklist";
import Templates from "./Screens/Tests/Templates";
import TemplateEditor from "./Screens/Tests/TemplateEditor";
import Billing from "./Screens/Billing/Billing";
import Analytic from "./Screens/Analytics/Analytic";
import Setting from "./Screens/Setting/Setting";
import Login from "./Screens/LogIn/Login";
import Sidebar from "./Components/Sidebar/Sidebar";
import Header from "./Components/Headar/Header";
import AuthProvider, { useAuth } from "./AuthProvider";
import RequireAuth from "./RequireAuth";
import ForcePasswordChange from "./Screens/Auth/ForcePasswordChange";
import { AppProvider } from "./AppProvider";

const Layout = () => {
  const { user, mustChangePassword } = useAuth();
  if (!user) return null;
  // A login created/reset by an admin must set its own password before anything else
  if (mustChangePassword) return <ForcePasswordChange />;
  return (
    <>
      <Sidebar />
      <Header />
      <Outlet />
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <RequireAuth />,
    children: [
      {
        path: "/",
        element: <Layout />,
        children: [
          { index: true, element: <Home /> },
          { path: "appointments", element: <Appointments /> },
          { path: "results", element: <Worklist /> },
          { path: "tests", element: <Templates /> },
          { path: "tests/:id", element: <TemplateEditor /> },
          { path: "catalogue", element: <Catalogue /> },
          { path: "packages", element: <Packages /> },
          { path: "billing", element: <Billing /> },
          { path: "analytic", element: <Analytic /> },
          { path: "setting", element: <Setting /> },
          { path: "*", element: <Navigate to="/" replace /> },
        ],
      },
    ],
  },
  { path: "/login", element: <Login /> },
]);

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <div className="App">
          <RouterProvider router={router} />
        </div>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
